module.exports = __webpack_public_path__ + "media/images/expert__jeff-baltermia-1cce5b1a6e77be539cab8e6b54a6a539.png";